import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import BillForm from './BillForm';
import BillFormService from '../services/BillFormService';
import BillProductsFormService from '../services/BillProductsFormService';
import { BRAZIL } from '../../../core/consts';

class BillFormContainer extends React.Component {
  static propTypes = {
    billId: PropTypes.string,
  };

  componentDidMount() {
    BillFormService.init();
    if (this.props.billId) {
      BillFormService.load(this.props.billId);
    }
  }

  handleReset() {
    BillFormService.form.reset();
    BillProductsFormService.form.reset();
  }

  render() {
    return (
      <BillForm
        onChange={BillFormService.handleChange}
        onSubmit={BillFormService.handleSubmit}
        values={BillFormService.form.getValues()}
        loading={BillFormService.fetch.fetching}
        submitting={BillFormService.submit.fetching}
        errors={BillFormService.form.errors}
        onReset={this.handleReset}
        total={BillFormService.total}
        currencyType={
          !BillFormService.form.getValue('country') || BRAZIL.includes(BillFormService.form.getValue('country'))
            ? 'real'
            : 'dollar'
        }
      />
    );
  }
}

export default observer(BillFormContainer);
